import styled from "styled-components"
import Info from "../img/infome.svg"
import Head from "../img/Vilosophy.svg"
import InfoContents from './InfoContents'
import { useState } from "react"
import "../App.css"

const TopMenuContents = styled.div`
  width: 1248px;
  margin: 0px 24px 0px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const LeftMenu = styled.div`
  width: 131px;
  height: 48px;
  background-color: #333;
  overflow: hidden;
  align-items: center;
  mask: url(${Head});
`

// const OrangeAni = keyframes`
//   0% {opacity: 0%};
//   45% {opacity: 0%}
//   50%{opacity: 100%};
//   95% {opacity: 100%}

//   100%{opacity: 0%}
// `

// const Orange = styled.div`
//   width: 200px;
//   height: 80px;
//   left: 0px;
//   background-color: #f28d00;
//   /* filter: blur(5px); */
//   animation: ${OrangeAni} 60s 0s infinite linear alternate;
// `

const RightMenu = styled.div`
  width: 48px;
  height: 48px;
  z-index: 4;
  background-color: #333;
  mask: url(${Info});
  &:hover {
    background-color: #f28d00;
  }
`
// const Info = styled.img`
//   display: inline-block;
//   position: relative;
//   left: 2px;
//   top: 3px;
//   width: 40px;
//   height: 19px;
// `

// const RightMenuBar01 = styled.div`
//   display: inline-block;
//   position: relative;
//   width: 6px;
//   height: 19px;
//   top: 3px;
//   background-color: #333;
// `

// const RightMenuBar02 = styled.div`
//   display: inline-block;
//   position: relative;
//   z-index: 2;
//   width: 48px;
//   height: 6px;
//   top: 6px;
//   background-color: #333;
// `

const InfoCon = styled.div`
  display: block;
  position: absolute;
  z-index: 5;
  width: 448px;
  height: auto;
  @media (max-width: 1296px) {
    left: calc(100% - 448px);
  }
  @media (max-width: 540px) {
    width: 100%;
    left: 0px;
  }

  left: calc(50% + 199px);
  top: 80px;
  border: 1px solid #bbb;
  background-color: #fff;
`
const InfoBack = styled.div`
  left: 0px;
  top: 0px;
  position: fixed;
  z-index: 3;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  opacity: 0;
`

function TopMenu() {
  const [menuContents, setContents] = useState(false)
  const transContents = () => {
    setContents(!menuContents)
  }
  return (
    <>
      <TopMenuContents>
        <LeftMenu></LeftMenu>
        <RightMenu onClick={transContents} isOpen={menuContents}>
          {/* <RightMenuBar01 /> */}
          {/* <Info /> */}
          {/* <RightMenuBar02 /> */}
        </RightMenu>
      </TopMenuContents>
      {menuContents && <InfoCon><InfoContents/></InfoCon>}
      {menuContents && (
        <InfoBack onClick={transContents} isOpen={menuContents}></InfoBack>
      )}
    </>
  )
}

export default TopMenu
